module.exports = __webpack_public_path__ + "static/img/news11_1.c74ba51.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/news/img/detail/news11_1.png
// module id = rIim
// module chunks = 0